module.exports = __webpack_public_path__ + "static/img/labour-1 .6e78899.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-1 .png
// module id = Ci2h
// module chunks = 1